import axios from "axios";

export let baseUrl =
  "https://trust-telecom-backend-e4655fbdb250.herokuapp.com/api/";
// export let baseUrl = "https://g85x8vg6-6001.inc1.devtunnels.ms/api/";

const api = async (path, params, method) => {
  let options;
  options = {
    headers: {
      "Content-Type": "application/json",
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;

// £
